import { Helmet } from "react-helmet-async";
import { CONTACT_INFO } from "../data";
import { getSiteOrigin } from "../../routes";

const DAILY_DAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];

function toOpeningHours() {
  return CONTACT_INFO.hours.map(({ days, time }) => {
    const [opens, closes] = time.split(/[–-]/).map((part) => part.trim());
    return {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: days === "Daily" ? DAILY_DAYS : [days],
      opens,
      closes
    };
  });
}

export function LocalBusinessSchema() {
  const origin = getSiteOrigin();
  const [longitude, latitude] = CONTACT_INFO.coordinates;

  const schema = {
    "@context": "https://schema.org",
    "@type": "Bakery",
    name: "Baldai",
    image: `${origin}/logo.png`,
    url: origin,
    telephone: CONTACT_INFO.phone,
    email: CONTACT_INFO.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: CONTACT_INFO.address,
      addressLocality: "Караганда",
      addressCountry: "KZ"
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude,
      longitude
    },
    openingHoursSpecification: toOpeningHours()
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
